const get = async endpoint => {
  let response;
  try {
    response = await fetch(endpoint);
  } catch (error) {
    if (!(error instanceof Error)) {
      console.error(error);
      return new Error("fetch() failed");
    }
    return error;
  }

  if (!response.ok) {
    console.error(response);
    return new Error("response is not ok");
  }

  let result;
  try {
    result = await response.text();
  } catch (error) {
    if (!(error instanceof Error)) {
      console.error(error);
      return new Error("response.text() failed");
    }
    return error;
  }

  return result;
};

const post = async (endpoint, body) => {
  let response;
  try {
    response = await fetch(endpoint, {
      body,
      headers: {
        "content-type": "application/json",
      },
      method: "POST",
    });
  } catch (error) {
    if (!(error instanceof Error)) {
      console.error(error);
      return new Error("fetch() failed");
    }
    return error;
  }

  if (!response.ok) {
    console.error(response);
    return new Error("response is not ok");
  }

  let result;
  try {
    result = await response.text();
  } catch (error) {
    if (!(error instanceof Error)) {
      console.error(error);
      return new Error("response.text() failed");
    }
    return error;
  }

  return result;
};

export const getDbMemberById = async memberId => {
  const body = await post(
    `/api/db/member/get-by-id`,
    JSON.stringify({
      memberId,
    })
  );
  if (body instanceof Error) return body;

  let user;
  try {
    user = JSON.parse(body);
  } catch (error) {
    if (!(error instanceof Error)) {
      console.error(error);
      return new Error("failed to parse response");
    }
    return error;
  }

  return user;
};

export const getDbUserById = async ({ saDisplayName, userId }) => {
  const body = await post(
    `/api/member/${encodeURIComponent(saDisplayName)}/db-user/get-by-id`,
    JSON.stringify({
      userId,
    })
  );
  if (body instanceof Error) return body;

  let user;
  try {
    user = JSON.parse(body);
  } catch (error) {
    if (!(error instanceof Error)) {
      console.error(error);
      return new Error("failed to parse response");
    }
    return error;
  }

  return user;
};

export const getAmbulatoryLearningPaths = async () => {
  const body = await get("/api/list-ambulatory-learning-paths");
  if (body instanceof Error) return body;

  let options;
  try {
    options = JSON.parse(body);
  } catch (error) {
    if (!(error instanceof Error)) {
      console.error(error);
      return new Error("failed to parse response");
    }
    return error;
  }

  return options;
};
export const getAcuteLearningPaths = async () => {
  const body = await get("/api/list-acute-learning-paths");
  if (body instanceof Error) return body;

  let options;
  try {
    options = JSON.parse(body);
  } catch (error) {
    if (!(error instanceof Error)) {
      console.error(error);
      return new Error("failed to parse response");
    }
    return error;
  }

  return options;
};

export const getUserByEmail = async ({ mail, saGroup }) => {
  const body = await post(
    `/api/member/${encodeURIComponent(saGroup)}/entra-user/get-by-mail`,
    JSON.stringify({
      mail,
    })
  );
  if (body instanceof Error) return body;

  let user;
  try {
    user = JSON.parse(body);
  } catch (error) {
    if (!(error instanceof Error)) {
      console.error(error);
      return new Error("failed to parse response");
    }
    return error;
  }

  return user;
};

export const getAmbulatoryLearningPathsForUser = async ({
  saDisplayName,
  userPrincipalName,
}) => {
  const body = await get(
    `/api/member/${encodeURIComponent(saDisplayName)}/user/${encodeURIComponent(
      userPrincipalName
    )}/get-ambulatory-learning-paths`
  );
  if (body instanceof Error) return body;

  let options;
  try {
    options = JSON.parse(body);
  } catch (error) {
    if (!(error instanceof Error)) {
      console.error(error);
      return new Error("failed to parse response");
    }
    return error;
  }

  return options;
};

export const addAmbulatoryLearningPathToUser = async ({
  saDisplayName,
  userPrincipalName,
  learningPath,
}) => {
  const resBody = await post(
    `/api/member/${encodeURIComponent(saDisplayName)}/user/${encodeURIComponent(
      userPrincipalName
    )}/add-ambulatory-learning-path`,
    JSON.stringify(learningPath)
  );
  if (resBody instanceof Error) return resBody;

  let options;
  try {
    options = JSON.parse(resBody);
  } catch (error) {
    if (!(error instanceof Error)) {
      console.error(error);
      return new Error("failed to parse response");
    }
    return error;
  }

  return options;
};

export const removeAmbulatoryLearningPathFromUser = async ({
  saDisplayName,
  userPrincipalName,
  learningPath,
}) => {
  const resBody = await post(
    `/api/member/${encodeURIComponent(saDisplayName)}/user/${encodeURIComponent(
      userPrincipalName
    )}/remove-ambulatory-learning-path`,
    JSON.stringify(learningPath)
  );
  if (resBody instanceof Error) return resBody;

  let options;
  try {
    options = JSON.parse(resBody);
  } catch (error) {
    if (!(error instanceof Error)) {
      console.error(error);
      return new Error("failed to parse response");
    }
    return error;
  }

  return options;
};

export const getAcuteLearningPathsForUser = async ({
  saDisplayName,
  userPrincipalName,
}) => {
  const body = await get(
    `/api/member/${encodeURIComponent(saDisplayName)}/user/${encodeURIComponent(
      userPrincipalName
    )}/get-acute-learning-paths`
  );
  if (body instanceof Error) return body;

  let options;
  try {
    options = JSON.parse(body);
  } catch (error) {
    if (!(error instanceof Error)) {
      console.error(error);
      return new Error("failed to parse response");
    }
    return error;
  }

  return options;
};

export const addAcuteLearningPathToUser = async ({
  saDisplayName,
  userPrincipalName,
  learningPath,
}) => {
  const resBody = await post(
    `/api/member/${encodeURIComponent(saDisplayName)}/user/${encodeURIComponent(
      userPrincipalName
    )}/add-acute-learning-path`,
    JSON.stringify(learningPath)
  );
  if (resBody instanceof Error) return resBody;

  let options;
  try {
    options = JSON.parse(resBody);
  } catch (error) {
    if (!(error instanceof Error)) {
      console.error(error);
      return new Error("failed to parse response");
    }
    return error;
  }

  return options;
};

export const removeAcuteLearningPathFromUser = async ({
  saDisplayName,
  userPrincipalName,
  learningPath,
}) => {
  const resBody = await post(
    `/api/member/${encodeURIComponent(saDisplayName)}/user/${encodeURIComponent(
      userPrincipalName
    )}/remove-acute-learning-path`,
    JSON.stringify(learningPath)
  );
  if (resBody instanceof Error) return resBody;

  let options;
  try {
    options = JSON.parse(resBody);
  } catch (error) {
    if (!(error instanceof Error)) {
      console.error(error);
      return new Error("failed to parse response");
    }
    return error;
  }

  return options;
};
